import styled from 'styled-components';
import { screen, spacing } from '../../../theme';
import { StyledFaqsSection } from '../shared/Faqs.styled';

export const StyledContainer = styled.div`
  ${StyledFaqsSection} {
    padding-top: ${spacing('xl4')};
    padding-bottom: ${spacing('xl3')};

    @media (min-width: ${screen('md')}) {
      padding-bottom: ${spacing('xl5')};
    }
  }
`;

export const StyledFaqsActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  gap: ${spacing('lg')} ${spacing('xl')};
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};
  padding-bottom: ${spacing('xl4')};
`;
